import styled from 'styled-components';

export const Wrapper = styled.div`
    width: 360px;
    box-sizing: border-box;
    border-radius: 6px;
    background-color: ${({ theme }) => theme.colors.white};
    display: grid;
    grid-template-rows: auto auto;
`;

export const Container = styled.div`
    padding: ${({ theme }) => theme.spacing * 2}px;
`;

export const Answer = styled.div`
    padding: ${({ theme }) => theme.spacing * 4}px ${({ theme }) => theme.spacing * 2}px;
    border-radius: 6px;
    background-color: ${({ theme }) => theme.colors.paleBlue};
    margin-bottom: ${({ theme }) => theme.spacing * 3}px;
`;

export const Image = styled.img`
    width: 100%;
    border-radius: 6px 6px 0 0;
`;

export const Question = styled.p`
    margin: 0 0 ${({ theme }) => theme.spacing * 2}px 0;
    font-size: 18px;
    color: ${({ theme }) => theme.colors.grayAlpha};
`;
